export const GET_PROMOTIONS = 'GET_PROMOTIONS';

export const getPromotions = promotions => ({
    type: GET_PROMOTIONS,
    promotions
});
